import { JsonObject, JsonProperty } from "ta-json";

import { QueryLoadingResource } from "../../models/query-loading-resource";
import { Query } from "./query";

@JsonObject()
export class QueryRequest extends QueryLoadingResource {
    @JsonProperty("Query")
    query: Query;

    constructor(init?: Partial<QueryRequest>) {
        super();
        Object.assign(this, init);
    }
}
